// This is the event name in GA, but called eventAction with ecg-js-ga-tracking
export const AnalyticsAction = {
  BUYER_MODAL: 'FavConnectBuyerOnboarding',
  SELLER_MODAL: 'FavConnectSellerOnboarding',
} as const;

export const FavouriteCategory = 'FavoritesConnect';

export const BuyerModalLabel = {
  IMPRESSION: 'impression',
  DISMISS: 'info_dismiss',
  MANAGE_NOTIFICATIONS: 'manage_notification_settings',
} as const;

export const SellerModalLabel = {
  IMPRESSION: 'impression',
  DISMISS: 'info_dismiss',
  MAKE_OFFER: 'make_offer',
  MANAGE_NOTIFICATIONS: 'manage_notification_settings',
} as const;

export type TrackEvent = (evt: { category: string; action: string; label?: string }) => void;
